require('./brokerStocksAdvancedSellStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const BuySellConditionTypeDropdown = require('components/broker/commons/buySellConditionTypeDropdown/buySellConditionTypeDropdown');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    BROKER_CONDITIONAL_ORDER_TERM,
    BROKER_RESTRICTED_ORDER_TERM,
    BROKER_INDEX_ORDER_CONDITION_VALUE,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_STOCKS_ADVANCED_SELL_PERCENTAGE_FIELDS_MAX_VALUE,
    BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER,
    EURO_TEXT,
    MAX_FRACTION_LENGTH_IN_STORE,
    TYPE_STOCKS,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ actions
const BrokerStocksAdvancedSellActions = require('actions/brokerStocksAdvancedSell');
const BrokerSearchActions = require('actions/brokerSearch');

// @ components
const BrokerSearchInput = require('components/broker/brokerSearch/brokerSearchInput/brokerSearchInput');
const { AmountInput } = require('commonsComponents/amountInput');

class BrokerStocksAdvancedSellStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleConditionTypeValueChanged = this.handleConditionTypeValueChanged.bind(this);
        this.handleConditionTypeChanged = this.handleConditionTypeChanged.bind(this);
    }

    buildAmountOrPointsField() {
        const { immBrokerStocksAdvancedSell, handleConditionTypeValueChanged } = this.props;
        const conditionTypeValue = immBrokerStocksAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'conditionTypeValue'
        ]);
        const isError =
            conditionTypeValue <= 0 &&
            !!immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP, 'conditionError']);

        return (
            <div className="stocks-advanced-sell-step1__condition-type-value-input">
                <AmountInput
                    id="conditionValue"
                    callback={handleConditionTypeValueChanged}
                    hideFocusZero={true}
                    amount={conditionTypeValue}
                    error={isError}
                    errorMsg={formatText('broker-stocksAdvancedSellConditionValueError')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                    language={language}
                />
            </div>
        );
    }

    buildConditionTypeValueSection() {
        const { immBrokerStocksAdvancedSell } = this.props;
        const conditionType = immBrokerStocksAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'conditionType'
        ]);
        const orderConditionValue = immBrokerStocksAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'orderConditionValue'
        ]);
        let conditionTypeValueField;
        let conditionTypeValueFieldLabelKey;
        let conditionTypeValueFieldLabelKeyParams;

        switch (conditionType) {
            case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                conditionTypeValueField = this.buildPercentageField();
                conditionTypeValueFieldLabelKey =
                    'broker-stocksAdvancedSellConditionTypePercentageValue';
                conditionTypeValueFieldLabelKeyParams = [];
                break;
            default:
                conditionTypeValueField = this.buildAmountOrPointsField();
                conditionTypeValueFieldLabelKey =
                    'broker-stocksAdvancedSellConditionTypeAmountOrPointsValue';
                conditionTypeValueFieldLabelKeyParams = [
                    orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                        ? formatText('broker-pointsText')
                        : EURO_TEXT
                ];
                break;
        }

        return (
            <div className="stocks-advanced-sell-step1__condition-type-value-section">
                <FormattedText
                    value={conditionTypeValueFieldLabelKey}
                    injectedStrings={conditionTypeValueFieldLabelKeyParams}
                    className="stocks-advanced-sell-step1__condition-type-value-label"
                />
                {conditionTypeValueField}
            </div>
        );
    }

    buildDinamycSection() {
        const {
            immBrokerStocksAdvancedSell,
            immSearchState,
            handleResetSelectedValues,
            handleInputSearchOnSearch,
            handleInputSearchProductSelected,
            orderTermValidityDateChanged
        } = this.props;

        const step1 = immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP]);
        const excludeDates = step1.get('excludeDates');
        const orderTerms = step1.get('orderTerms');
        const isInputSearchFetching = immSearchState.get('isFetching');
        const orderConditionValue = step1.get('orderConditionValue');
        const conditionType = step1.get('conditionType');
        const conditionTypeValueSection = this.buildConditionTypeValueSection();
        const firstDate = step1.get('firstDate');
        const limitDate = step1.get('limitDate');
        const validityDate = step1.get('validityDate');
        const stockId = step1.get('stockId');

        let dinamycSection = (
            <FormattedText
                value="broker-stocksAdvancedSellEverithingOrNothing"
                className="stocks-advanced-sell-step1__restricted-order-text"
            />
        );

        const inputSearchResults = immSearchState.get('results').filter(item =>
            item.get('type') === TYPE_STOCKS &&
            (
                item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE ||
                item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK
            )

        );

        if (orderTerms === BROKER_CONDITIONAL_ORDER_TERM) {
            dinamycSection = (
                <div className="stocks-advanced-sell-step1__group-div">
                    <h3 className="stocks-advanced-sell-step1__section-title">
                        <FormattedText value="broker-stocksAdvancedSellOrderConditionTypeSectionTitle" />
                    </h3>
                    <div className="stocks-advanced-sell-step1__subgroup-div">
                        <h4 className="stocks-advanced-sell-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedSellOrderConditionValueSubtitle" />
                            <OKTooltip
                                offset={[0, -15]}
                                content="broker-stocksAdvancedSellOrderConditionValueTooltip"
                            />
                        </h4>
                        <div className="stocks-advanced-sell-step1__search-input">
                            <FormattedText value="broker-stocksAdvancedSellStocksConditionValue" />
                            <BrokerSearchInput
                                placeholder={formatText(
                                    'broker-stocksAdvancedSellSearchPlaceholder'
                                )}
                                noResultsText={formatText('broker-searchEmptyText')}
                                isLoading={isInputSearchFetching}
                                results={inputSearchResults}
                                onSearch={handleInputSearchOnSearch}
                                onSelection={handleInputSearchProductSelected}
                                selectedValue={stockId}
                                resetSelectedValuesOnInput={true}
                                onResetSelectedValues={handleResetSelectedValues}
                                modifier={BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER}
                                errorState={step1.get('emptyStockError')}
                                errorMessage={formatText(
                                    'broker-stocksAdvancedSellStockValueError'
                                )}
                            />
                        </div>
                    </div>
                    <div className="stocks-advanced-sell-step1__subgroup-div">
                        <h4 className="stocks-advanced-sell-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedSellDriverEventSubtitle" />
                            <OKTooltip
                                offset={[0, -15]}
                                content="broker-stocksAdvancedSellDriverEventTooltip"
                            />
                        </h4>
                        <div className="stocks-advanced-sell-step1__condition-type-dropdown">
                            <BuySellConditionTypeDropdown
                                onConditionTypeChange={this.handleConditionTypeChanged}
                                selectedValue={conditionType}
                                isConditionOnMarketIndex={
                                    orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                                }
                            />
                        </div>
                        {conditionTypeValueSection}
                    </div>
                    <div>
                        <h4 className="stocks-advanced-sell-step1__section-subtitle stocks-advanced-sell-step1__clear">
                            <FormattedText value="broker-stocksAdvancedSellValidityDateSubtitle" />
                            <OKTooltip
                                offset={[0, -15]}
                                content="broker-stocksAdvancedSellValidityDateTooltip"
                            />
                        </h4>
                        <div className="stocks-advanced-sell-step1__date-picker">
                            <DatePickerCustom
                                callback={orderTermValidityDateChanged}
                                selectedDate={validityDate}
                                newSelectedDate={validityDate}
                                maxDate={limitDate}
                                minDate={firstDate}
                                excludeDates={excludeDates}
                                placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                                locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return dinamycSection;
    }

    buildPercentageField() {
        const { immBrokerStocksAdvancedSell } = this.props;
        const onHandleConditionInputChange = this.handleConditionTypeValueChanged;
        const conditionTypeValue = immBrokerStocksAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'conditionTypeValue'
        ]);
        const isError =
            conditionTypeValue <= 0 &&
            !!immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP, 'conditionError']);
        return (
            <div className="stocks-advanced-sell-step1__condition-type-value-input">
                <AmountInput
                    id="conditionValuePercentage"
                    callback={onHandleConditionInputChange}
                    amount={conditionTypeValue}
                    min={0}
                    max={BROKER_STOCKS_ADVANCED_SELL_PERCENTAGE_FIELDS_MAX_VALUE}
                    maxFractionLength={2}
                    hideFocusZero={true}
                    maxBackEndFractionLength={2}
                    error={isError}
                    errorMsg={formatText('broker-stocksAdvancedSellConditionValueError')}
                    language={language}
                />
            </div>
        );
    }

    handleConditionTypeChanged(value) {
        this.props.handleConditionTypeValueChanged(0);
        this.props.handleConditionTypeChanged(value);
    }

    handleConditionTypeValueChanged(val) {
        this.props.handleConditionTypeValueChanged(val);
    }

    render() {
        const { immBrokerStocksAdvancedSell, handleOrderTermsChanged } = this.props;

        const step1 = immBrokerStocksAdvancedSell.getIn(['steps', FIRST_STEP]);
        const orderTerms = step1.get('orderTerms');
        const dinamycSection = this.buildDinamycSection();
        const orderTermsSectionClassesGroup = classNames(
            'stocks-advanced-sell-step1__group-div',
            'hidden',
            {
                'stocks-advanced-sell-step1__group-div--no-margin':
                    orderTerms === BROKER_RESTRICTED_ORDER_TERM
            }
        );
        const orderTermsSectionClassesSubgroup = classNames(
            'stocks-advanced-sell-step1__subgroup-div',
            {
                'stocks-advanced-sell-step1__subgroup-div--no-margin':
                    orderTerms === BROKER_RESTRICTED_ORDER_TERM
            }
        );

        return (
            <div className="stocks-advanced-sell-step1">
                <header className="stocks-advanced-sell-step1__header">
                    <h2 className="stocks-advanced-sell-step1__header-title">
                        <FormattedText value="broker-stocksAdvancedSellHeaderTitle" />
                    </h2>
                </header>
                <section className={orderTermsSectionClassesGroup}>
                    <h3 className="stocks-advanced-sell-step1__section-title">
                        <FormattedText value="broker-stocksAdvancedSellAdvancedOrderTypeSectionTitle" />
                    </h3>
                    <div className={orderTermsSectionClassesSubgroup}>
                        <h4 className="stocks-advanced-sell-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedSellOrderTypeSubtitle" />
                            <OKTooltip
                                offset={[0, -15]}
                                content="broker-stocksAdvancedSellOrderTypeTooltip"
                            />
                        </h4>
                        <RadioButtonGroup
                            selectedValue={orderTerms}
                            onChange={handleOrderTermsChanged}
                            name="orderTermsRadioGroup"
                            idPrefix="orderTermsRadioGroup"
                        >
                            <RadioButton
                                label={formatText('broker-stocksAdvancedSellConditionalOrderTerm')}
                                value={BROKER_CONDITIONAL_ORDER_TERM}
                                className="stocks-advanced-sell-step1__radio-button"
                            />
                            <RadioButton
                                label={formatText('broker-stocksAdvancedSellRestrictedOrderTerm')}
                                value={BROKER_RESTRICTED_ORDER_TERM}
                                className="stocks-advanced-sell-step1__radio-button"
                            />
                        </RadioButtonGroup>
                    </div>
                </section>
                {dinamycSection}
            </div>
        );
    }
}

BrokerStocksAdvancedSellStep1.propTypes = {
    immBrokerStocksAdvancedSell: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    handleOrderTermsChanged: PropTypes.func.isRequired,
    handleResetSelectedValues: PropTypes.func.isRequired,
    handleInputSearchOnSearch: PropTypes.func.isRequired,
    handleInputSearchProductSelected: PropTypes.func.isRequired,
    handleOrderConditionValueChanged: PropTypes.func.isRequired,
    handleConditionTypeChanged: PropTypes.func.isRequired,
    handleConditionTypeValueChanged: PropTypes.func.isRequired,
    orderTermValidityDateChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerStocksAdvancedSellStep1;

module.exports.BrokerStocksAdvancedSellStep1 = connect(
    state => ({
        immBrokerStocksAdvancedSell: state.brokerStocksAdvancedSell,
        immSearchState: state.brokerSearch
    }),
    {
        handleOrderTermsChanged: BrokerStocksAdvancedSellActions.orderTermsChanged,
        handleResetSelectedValues: BrokerSearchActions.resetSelectedResults,
        handleInputSearchOnSearch: BrokerSearchActions.searchAllProducts,
        handleInputSearchProductSelected:
            BrokerStocksAdvancedSellActions.inputSearchProductSelected,
        handleOrderConditionValueChanged:
            BrokerStocksAdvancedSellActions.orderConditionValueChanged,
        handleConditionTypeChanged: BrokerStocksAdvancedSellActions.conditionTypeChanged,
        handleConditionTypeValueChanged: BrokerStocksAdvancedSellActions.conditionTypeValueChanged,
        orderTermValidityDateChanged: BrokerStocksAdvancedSellActions.orderTermValidityDateChanged
    }
)(BrokerStocksAdvancedSellStep1);
